import catalog from "./specialistCatalog.json";
import type { ToolCategory, ToolDefinition } from "./types";
const inspector = () => import("./pages/BinaryInspectorTool");
const loaders: Record<string, NonNullable<ToolDefinition["loader"]>> = {
  "git-patch": () => import("./pages/workbenches/StreamWorkbenches"),
  "sse-inspector": () => import("./pages/workbenches/StreamWorkbenches"),
  "ansi-log": () => import("./pages/workbenches/StreamWorkbenches"),
  "websocket-frame": () => import("./pages/workbenches/WireWorkbenches"),
  "bencode-inspector": () => import("./pages/workbenches/WireWorkbenches"),
  "http-chunked": () => import("./pages/workbenches/WireWorkbenches"),
  "ssh-key": () => import("./pages/workbenches/EncodedWorkbenches"),
  "saml-inspector": () => import("./pages/workbenches/EncodedWorkbenches"),
  "cid-inspector": () => import("./pages/workbenches/EncodedWorkbenches"),
  "base58-codec": () => import("./pages/workbenches/EncodedWorkbenches"),
  "crc-checksum": () => import("./pages/workbenches/EncodedWorkbenches"),
  "image-channels": () => import("./pages/workbenches/ImageChannelsTool"),
  "pdf-preflight": () => import("./pages/PdfAdvancedTool"),
  "pdf-poster": () => import("./pages/PdfAdvancedTool"),
  "docx-revisions": () => import("./pages/DocxReviewTool"),
  "audio-spectrum": () => import("./pages/AudioSpectrumTool"),
  "jwe-workbench": () => import("./pages/AdvancedCryptoTool"),
  "hkdf-workbench": () => import("./pages/AdvancedCryptoTool"),
};
export const specialistDefinitions: ToolDefinition[] = catalog.map((entry) => ({
  ...entry,
  category: entry.category as ToolCategory,
  status: "available",
  localOnly: true,
  loader: loaders[entry.id] || inspector,
}));
